import { render } from "./PersonalDetail.vue?vue&type=template&id=cb344b1a&scoped=true"
import script from "./PersonalDetail.vue?vue&type=script&lang=js"
export * from "./PersonalDetail.vue?vue&type=script&lang=js"

import "./PersonalDetail.vue?vue&type=style&index=0&id=cb344b1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb344b1a"]])

export default __exports__